import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = {
  class: "tooltip indicator",
  "data-tip": "Open console with compilation output"
}
const _hoisted_5 = { class: "p-1 indicator" }
const _hoisted_6 = {
  key: 0,
  class: "indicator-item indicator-middle indicator-center"
}

import { ref, computed, watch } from "vue";
import { err } from "@/utils";
import { useBackendStore, useFirmwareStore } from "@/stores";
import { useOnClickOutside } from "@/composables";
import PopUp from "@/components/utils/PopUp.vue";
import ConsoleOutput from "@/components/ConsoleOutput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CompileFirmwareButton',
  setup(__props) {

const backend = useBackendStore();
const firmware = useFirmwareStore();

const consolePopupGroup = ref<HTMLElement | null>(null);
const consoleOutput = ref<InstanceType<typeof ConsoleOutput> | null>(null);
const consoleButton = ref<HTMLElement | null>(null);
const consoleOpen = ref(false);
const consoleUnread = ref(0);

// Close popup when clicking outside
useOnClickOutside(consolePopupGroup, () => (consoleOpen.value = false));

// Keep track of unread messages
watch(consoleOpen, (open) => {
  if (open) {
    consoleUnread.value = 0;
    setTimeout(() => consoleOutput.value?.scroll());
  }
});
watch(
  () => firmware.consoleOutputCount,
  (newCount, oldCount) => {
    if (newCount == 0) consoleUnread.value = 0;
    else if (!consoleOpen.value) {
      const diff = newCount - oldCount;
      consoleUnread.value += Math.max(0, diff);
    }
  }
);

const compileButtonText = computed(() =>
  firmware.buildStatus == "PENDING"
    ? "Pending…"
    : firmware.buildStatus == "RUNNING"
    ? "Compiling…"
    : "Compile"
);

const compileButtonTooltip = computed(() => {
  if (backend.currentConfig == null || backend.configModified)
    return err("Configuration changes must first be saved");
  return "Compile keyboard firmware using current configuration";
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "consolePopupGroup",
    ref: consolePopupGroup,
    class: "flex items-center btn-group-border"
  }, [
    _createElementVNode("div", {
      class: "tooltip w-full",
      "data-tip": compileButtonTooltip.value
    }, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(firmware).compile && _unref(firmware).compile(...args))),
        class: "btn btn-neutral btn-group-start min-w-[12rem] w-full",
        disabled: 
          _unref(backend).currentConfig == null ||
          _unref(backend).configModified ||
          compileButtonText.value != 'Compile'
        
      }, [
        (compileButtonText.value != 'Compile')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(compileButtonText.value), 1)
      ], 8, _hoisted_2)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("span", { class: "indicator-item badge badge-primary px-1.5" }, _toDisplayString(consoleUnread.value < 100 ? consoleUnread.value.toString() : "99+"), 513), [
        [_vShow, consoleUnread.value > 0]
      ]),
      _createElementVNode("button", {
        ref_key: "consoleButton",
        ref: consoleButton,
        class: "btn btn-neutral btn-group-end",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (consoleOpen.value = !consoleOpen.value))
      }, [
        _createVNode(_component_Icon, {
          icon: "mdi:console",
          class: "text-xl"
        })
      ], 512)
    ]),
    _createVNode(PopUp, {
      show: consoleOpen.value,
      reference: consoleButton.value,
      placement: "top",
      offset: 8
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (!_unref(firmware).consoleActive)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "-translate-x-1/2 -translate-y-1/2 text-base-100 min-w-max text-center text-xl" }, " Not connected to server ", -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(ConsoleOutput, {
            ref_key: "consoleOutput",
            ref: consoleOutput,
            class: _normalizeClass(["w-[520px] h-[520px] md:w-[760px] md:h-[420px]", _unref(firmware).consoleActive ? '' : 'opacity-60'])
          }, null, 8, ["class"])
        ])
      ]),
      _: 1
    }, 8, ["show", "reference"])
  ], 512))
}
}

})